export default "__VITE_ASSET__DEwqRW8C__"